import axios from "axios";
import {
  checkPayEndpoint,
  payEndpoint,
  testMobileNumber,
} from "../../../routes/api_endpoints";
import { receiptContent } from "./email_service";
import { API_KEY } from "../../../utilities/apiKey";

export const createCardPayment = ({
  cc_number = "",
  cc_name = "",
  cc_cvv = "",
  cc_exp = "",
}) => ({
  type: "CARDS",
  payment: {
    cc_number: cc_number,
    cc_name: cc_name,
    cc_cvv: cc_cvv,
    cc_exp: cc_exp,
  },
});

export const createPayload = ({
  MovieProviderID = "6166ebc5180b4",
  MovieID = "57785",
  ScreenID = "57785",
  ShowID = "57785",
  ShowDate = "12:00 PM",
  Seats = { E4: { SeatPrice: 600, SeatNumber: "E4", TicketCode: "2156" } },
  MovieTicketCost = 0,
  Markup = 0,
  PromoCode = "",
  PromoAmount = 0,
  WalletUniqueID = "",
}) => ({
  MovieDetails: {
    MovieProviderID,
    MovieID,
    ScreenID,
    Seats: Object.values(Seats),
    Quantity: Object.values(Seats).length,
    Markup,
    PromoCode,
    PromoAmount,
    MovieTicketCost,
  },
  ShowID,
  WalletUniqueID,
  WalletID: WalletUniqueID,
  ShowDate,
});

/**A request to initiate payment
 * @param payload Data that will be sent to the payment api
 * @param paymentDetails The payment method being used
 * @param content Data that will be sent to the email api
 * @param email The email address of the person paying
 */
const paymentFunction = (
  payload = createPayload(),
  paymentDetails = {
    type: "MPESA",
    payment: {
      mobile: "254702695801",
    },
  },
  content = receiptContent(),
  email = "test@mail.com",
  phone = testMobileNumber
) =>
  new Promise((resolve, reject) => {
    axios
      .post(
        payEndpoint,
        {
          payload,
          paymentDetails,
          content,
          email,
          phone,
        },
        {
          headers: {
            "X-API-KEY": API_KEY,
          },
        }
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.stage
        ) {
          switch (error.response.data.stage) {
            case "payment":
              reject({ stage: "payment", data: error.response.data.data });
              break;
            case "booking":
              reject({ stage: "booking", data: error.response.data });
              break;
            case "email":
              resolve();
              break;
            default:
              reject(error.response.data);
              break;
          }
        } else {
          reject(error);
        }
      });
  });

export const payWithWallet = (
  payload = createPayload(),
  paymentDetails = {
    type: "MPESA",
    payment: {
      mobile: "254702695801",
    },
  },
  content = receiptContent(),
  email = "test@mail.com",
  phone = testMobileNumber
) =>
  new Promise((resolve, reject) => {
    axios
      .post(`${payEndpoint}/payWithWallet`, {
        payload,
        paymentDetails,
        content,
        email,
        phone,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.stage
        ) {
          switch (error.response.data.stage) {
            case "payment":
              reject({ stage: "payment", data: error.response.data.data });
              break;
            case "booking":
              reject({ stage: "booking", data: error.response.data });
              break;
            case "email":
              resolve();
              break;
            default:
              reject(error.response.data);
              break;
          }
        } else {
          reject(error);
        }
      });
  });
export const checkPaymentAgain = (
  key = "movies/123456",
  payload = createPayload({}),
  reference = "23864739-2043568-sdc0294385",
  content = receiptContent(),
  email = "test@mail.com"
) =>
  new Promise((resolve, reject) => {
    axios
      .post(checkPayEndpoint, {
        key,
        payload,
        reference,
        content,
        email,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default paymentFunction;
